import type { ProfileProgress as ProfileProgressType } from '@/types';

interface ProfileProgressProps {
  progress: ProfileProgressType;
}

export function ProfileProgress({ progress }: ProfileProgressProps) {
  const { steps } = progress;
  const completedCount = steps.filter(s => s.status === 'complete').length;
  const totalCount = steps.length;
  const allDone = completedCount === totalCount;

  // Find the current step being worked on
  const currentStep = steps.find(s => s.status === 'in_progress');
  const lastCompleted = [...steps].reverse().find(s => s.status === 'complete');

  // Determine display label
  let label: string;
  let icon: string;

  if (allDone) {
    label = `Account profile ready — ${totalCount}/${totalCount} complete`;
    icon = '\u2713';
  } else if (currentStep) {
    label = currentStep.label + '...';
    icon = '\u23F3';
  } else if (lastCompleted) {
    label = lastCompleted.detail ?? `${lastCompleted.label} done`;
    icon = '\u23F3';
  } else {
    label = 'Scanning account...';
    icon = '\u23F3';
  }

  const progressPercent = (completedCount / totalCount) * 100;

  return (
    <div className="py-3 px-1">
      <div className="flex items-center gap-2 text-sm text-muted-foreground mb-1.5">
        <span>{icon}</span>
        <span>{label}</span>
      </div>
      <div className="h-1 w-48 rounded-full bg-muted overflow-hidden">
        <div
          className="h-full rounded-full bg-primary transition-all duration-500 ease-out"
          style={{ width: `${progressPercent}%` }}
        />
      </div>
    </div>
  );
}
